import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { InternalComponent } from './internal.component';
import { ContentComponentModule } from '@shared/gui/structural-components/content-component/content.component.module';
import { NavigationComponentModule } from '@shared/gui/structural-components/navigation-component/navigation.component.module';
import { RouterModule, Routes } from '@angular/router';
import { internalRoutes } from './internal.routes';
import { InternalAppInitialisationService } from '@internal-services/app-initialisation.service';

@NgModule({
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	declarations: [InternalComponent],
	imports: [ContentComponentModule, NavigationComponentModule, RouterModule.forChild(internalRoutes as Routes)],
	providers: [
		InternalAppInitialisationService,
		/* ...InternalServices, 
		...InternalProviders, 
		...InternalManagers,
		...InternalControllers */
	],
})
export class InternalModule {}
